/*=============================
=           Dropzone          =
=============================*/

const { Dropzone } = require('dropzone');

var fileField = document.querySelector('.dropzone');

if(fileField) {
	var fileFieldId = fileField.parentNode.getAttribute('data-id'),
		maxFiles = fileField.getAttribute('data-max-files'),
		maxFilesize = fileField.getAttribute('data-max-filesize'),
		accepted = fileField.getAttribute('data-accepted'),
		fileDrop = new Dropzone('.dropzone', {
			maxFiles: maxFiles ? parseInt(maxFiles) : 1,
			maxFilesize: maxFilesize ? parseInt(maxFilesize) : 5,
			acceptedFiles: JSON.parse(accepted).join(','),
			autoProcessQueue: false,
			addRemoveLinks: true,
			url: '/process-form',
			dictDefaultMessage: 'Drag-and-drop files here or<button type="button" title="button for input to upload files"></button> click to select from your computer'
		});
}

var resumeDZ = document.getElementById('resume-dropzone'),
	hiddenDZ = document.querySelector('.dz-hidden-input');

if(resumeDZ && hiddenDZ) {
	hiddenDZ.setAttribute('aria-labelledby', 'resume-dropzone');
}

/*=============================
=         Form Process        =
=============================*/

var formMessage = document.getElementById('form-message');

[].slice.call(document.querySelectorAll('.ajax-form')).forEach(function(form) {
	form.addEventListener('submit', formProcess);
});

function formProcess(e) {
	if('performance' in window === false)
		return true;

	e.preventDefault();

	var form = this,
		data = new FormData(form),
		button = this.querySelector('button[type="submit"]');

	button.classList.add('disabled');

	// Add File Uploads to Form Data
	if(fileField && fileDrop) {
		var files = fileDrop.files.filter(function(f) { return f.accepted; });

		// For validation, if field is required
		if(files.length)
			data.append(fileFieldId, 'File(s) Uploaded');

		for(var f=0; f<files.length; f++)
			data.append(fileFieldId+f, files[f]);
	}

	data.append('c_time', performance.now() >= 7000 ? 0 : 1);

	axios.post(form.action, data)
		.then(function(r) {
			Velocity(form, 'slideUp', {duration: 500, delay: 500});
			clearErrors(form);
			formMessage.classList.add('success');
			formMessage.innerHTML = r.data.message;

			if(typeof dataLayer !== 'undefined')
				dataLayer.push({'event': 'FormSubmission'});
		})
		.catch(function (e) {
			setTimeout(function() {
				button.classList.remove('disabled');
			}, 500);

			console.log(e.response.data.errors);

			formMessage.classList.add('error');
			formMessage.innerHTML = e.response.data.message;

			if(e.response.status===422) {
				clearErrors(form);
				setErrors(form, e.response.data.errors);
			}
		});
}

function clearErrors(form) {
	var errors = form.getElementsByClassName('error');

	for(var e=errors.length - 1; e>=0; e--)
		errors[e].classList.remove('error');

	Velocity(formMessage, 'scroll', {
		duration: 500,
		offset: -header.offsetHeight
	});
}

function setErrors(form, errors) {
	var firstField = false;

	if(Object.keys(errors).length) {
		var errorsList = document.createElement('ul');

		formMessage.appendChild(errorsList);
	}

	for(var key in errors) {
		var label = form.querySelector('label[for="'+key+'"]') || document.querySelector('fieldset[data-id="'+key+'"] legend');

		if (label) {
			label.parentNode.classList.add('error');
		}

		if(key == 'g-recaptcha-response')
			document.querySelector('.g-recaptcha').classList.add('error');

		var field = form.querySelector('*[name="'+key+'"], fieldset[data-id="'+key+'"] .dropzone');

		if (field) {
			field.setAttribute('aria-describedby', key+'_error');

			if(!firstField) {
				field.focus();
				firstField = true;
			}

			var li = document.createElement('li');

			li.setAttribute('id', key+'_error');
			li.innerHTML = errors[key];
			errorsList.appendChild(li);
		}
	}
}


/*=============================
=          Physicians         =
=============================*/

(function() {
	function initPhysicianSliders() {
		document.querySelectorAll('.doctors-slider').forEach(function(doctorsSlider) {
			if (doctorsSlider.dataset.sliderInitialized === 'true') return;

			doctorsSlider.dataset.sliderInitialized = 'true';

			var doctorsCards = doctorsSlider.querySelectorAll('.image-card'),
				cardsTotal = doctorsCards.length,
				currentCard = 0,
				numDisplay = 1,
				cardInterval = null,
				resizeTimer = null,
				mobileQuery = window.matchMedia('(max-width: 767px)');

			if (!cardsTotal) return;

			function getStep() {
				if (doctorsCards.length >= 2) {
					return doctorsCards[1].offsetLeft - doctorsCards[0].offsetLeft;
				}

				return doctorsCards[0].offsetWidth;
			}

			function getNumDisplay() {
				if (mobileQuery.matches) {
					return 1;
				}

				var firstCard = doctorsCards[0];
				var wrapper = firstCard.parentElement.parentElement;
				var wrapperStyle = getComputedStyle(wrapper);
				var visibleWidth = wrapper.clientWidth
					- parseFloat(wrapperStyle.paddingLeft || 0)
					- parseFloat(wrapperStyle.paddingRight || 0);

				var cardWidth = firstCard.offsetWidth;
				var step = getStep();

				if (!visibleWidth || !cardWidth) {
					return 1;
				}

				if (!step || step < cardWidth) {
					step = cardWidth;
				}

				var gap = step - cardWidth;
				var fit = Math.floor((visibleWidth + gap) / step);

				return Math.min(cardsTotal, Math.max(1, fit));
			}

			function sliderIsNeeded() {
				return cardsTotal > getNumDisplay();
			}

			function getMaxCard() {
				return Math.max(0, cardsTotal - getNumDisplay());
			}

			function getTotalPages() {
				return Math.ceil(cardsTotal / getNumDisplay());
			}

			function getCurrentPage() {
				var maxCard = getMaxCard();

				if (currentCard >= maxCard) {
					return getTotalPages() - 1;
				}

				return Math.floor(currentCard / getNumDisplay());
			}

			function clampCurrentCard() {
				var maxCard = getMaxCard();

				if (currentCard > maxCard) {
					currentCard = maxCard;
				}

				if (currentCard < 0) {
					currentCard = 0;
				}
			}

			function createBullets() {
				var bulletsContainer = doctorsSlider.querySelector('.bullets');

				if (!bulletsContainer) return;

				numDisplay = getNumDisplay();

				var totalPages = getTotalPages();
				var currentPage = getCurrentPage();

				bulletsContainer.innerHTML = '';

				for (var i = 0; i < totalPages; i++) {
					var bullet = document.createElement('button');
					bullet.className = 'bullet';
					bullet.setAttribute('aria-label', 'Slide ' + (i + 1));

					if (i === currentPage) {
						bullet.classList.add('current');
					}

					bullet.addEventListener('click', function(index) {
						return function() {
							clearInterval(cardInterval);
							goToPage(index);
						};
					}(i));

					bulletsContainer.appendChild(bullet);
				}
			}

			function updateBullets() {
				var bulletsContainer = doctorsSlider.querySelector('.bullets');
				var currentPage = getCurrentPage();

				if (!bulletsContainer) return;

				Array.from(bulletsContainer.children).forEach(function(bullet, index) {
					bullet.classList.toggle('current', index === currentPage);
				});
			}

			function goToPage(pageIndex) {
				currentCard = Math.min(pageIndex * getNumDisplay(), getMaxCard());
				clampCurrentCard();
				updateSlider();
			}

			function slidePhysician(direction) {
				if (!sliderIsNeeded()) return;

				var isNext = direction === 'next';
				var currentPage = getCurrentPage();
				var totalPages = getTotalPages();

				if (isNext) {
					currentPage = currentPage >= totalPages - 1 ? 0 : currentPage + 1;
				} else {
					currentPage = currentPage <= 0 ? totalPages - 1 : currentPage - 1;
				}

				goToPage(currentPage);
			}

			function autoSlidePhysician() {
				slidePhysician('next');
			}

			function startAutoSlide() {
				clearInterval(cardInterval);

				if (sliderIsNeeded()) {
					cardInterval = setInterval(autoSlidePhysician, 5000);
				}
			}

			function updateSlider() {
				numDisplay = getNumDisplay();

				var needsSlider = sliderIsNeeded();
				var cardsContainer = doctorsSlider.querySelector('.cards-container');
				var prevButton = doctorsSlider.querySelector('button.prev');
				var nextButton = doctorsSlider.querySelector('button.next');

				if (!cardsContainer || !prevButton || !nextButton) return;

				doctorsSlider.classList.toggle('few-cards', !needsSlider);

				if (!needsSlider) {
					currentCard = 0;
					cardsContainer.style.transform = 'translateX(0)';
					prevButton.disabled = true;
					nextButton.disabled = true;
					updateBullets();
					return;
				}

				clampCurrentCard();

				var step = getStep();
				var currentPage = getCurrentPage();

				cardsContainer.style.transform = 'translateX(' + (-currentCard * step) + 'px)';
				prevButton.disabled = currentPage === 0;
				nextButton.disabled = currentPage >= getTotalPages() - 1;

				updateBullets();
			}

			function refreshPhysicianSlider() {
				createBullets();
				updateSlider();
				startAutoSlide();
			}

			[].slice.call(doctorsSlider.querySelectorAll('button.prev, button.next')).forEach(function(button) {
				button.addEventListener('click', function() {
					clearInterval(cardInterval);
					slidePhysician(button.classList.contains('next') ? 'next' : 'prev');
				});
			});

			window.addEventListener('resize', function() {
				clearTimeout(resizeTimer);

				resizeTimer = setTimeout(function() {
					refreshPhysicianSlider();
				}, 150);
			});

			window.addEventListener('load', function() {
				refreshPhysicianSlider();
			});

			window.addEventListener('pageshow', function() {
				refreshPhysicianSlider();
			});

			if (document.fonts && document.fonts.ready) {
				document.fonts.ready.then(function() {
					refreshPhysicianSlider();
				});
			}

			if ('ResizeObserver' in window) {
				var sliderObserver = new ResizeObserver(function() {
					clearTimeout(resizeTimer);

					resizeTimer = setTimeout(function() {
						refreshPhysicianSlider();
					}, 150);
				});

				sliderObserver.observe(doctorsSlider);
			}

			[].slice.call(doctorsSlider.querySelectorAll('img')).forEach(function(img) {
				if (img.complete) return;

				img.addEventListener('load', refreshPhysicianSlider, { once: true });
				img.addEventListener('error', refreshPhysicianSlider, { once: true });
			});

			refreshPhysicianSlider();

			requestAnimationFrame(function() {
				refreshPhysicianSlider();
			});

			setTimeout(refreshPhysicianSlider, 250);
			setTimeout(refreshPhysicianSlider, 750);
			setTimeout(refreshPhysicianSlider, 1500);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initPhysicianSliders);
	} else {
		initPhysicianSliders();
	}

	window.addEventListener('load', initPhysicianSliders);
}());